import clsx from "clsx";
import { Check, Copy } from "lucide-react";
import type React from "react";
import { useState } from "react";
import { Input, InputGroup } from "@/components/catalyst/Input";

interface CopyableInputProps
	extends React.ComponentPropsWithoutRef<typeof Input> {
	value: string;
}

export function CopyableInput({
	value,
	className,
	...props
}: CopyableInputProps) {
	const [copied, setCopied] = useState(false);

	const handleCopy = async () => {
		await navigator.clipboard.writeText(value);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	};

	return (
		<InputGroup>
			<Input
				readOnly
				value={value}
				onClick={(e) => {
					e.currentTarget.select();
					handleCopy();
				}}
				className={clsx(
					"font-mono text-sm cursor-pointer! hover:border-primary transition-colors",
					className,
				)}
				{...props}
			/>
			{copied ? (
				<Check data-slot="icon" className="text-success pointer-events-none" />
			) : (
				<Copy
					data-slot="icon"
					className="text-base-content/50 pointer-events-none"
				/>
			)}
		</InputGroup>
	);
}
